import React from 'react';
import { ArrowRight, FileBarChart, TrendingUp, PieChart, BarChart3, Check } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_research-hub-218/artifacts/lk2wm99x_Skoop%21%20Logo%20-%202026.jpg";
const STRIPE_URL = "https://buy.stripe.com/6oU9AU5DN6vUdEq9MObAs08";

export default function GetTheSkoopPage() {
  return (
    <div data-testid="get-the-skoop-page">
      {/* Hero */}
      <section className="bg-[#0A192F] py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <img src={LOGO_URL} alt="SKOOP! Logo" className="h-24 w-auto mx-auto mb-6 animate-fade-up p-2 bg-white/10 rounded-2xl backdrop-blur-sm" style={{ filter: 'drop-shadow(0 0 30px rgba(56,189,248,0.3))' }} />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white mb-4 animate-fade-up animate-delay-100" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Get the SKOOP!
          </h1>
          <p className="text-lg text-white/70 max-w-2xl mx-auto animate-fade-up animate-delay-200" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Subscribe to receive the results from our community research studies delivered straight to you.
          </p>
        </div>
      </section>

      {/* Pricing + Features Box */}
      <section className="py-16 sm:py-20 bg-[#F8FAFC]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="neo-card p-8 sm:p-10">
            {/* Price */}
            <div className="text-center mb-8 pb-8 border-b-2 border-[#0A192F]/10">
              <p className="text-sm font-bold uppercase tracking-widest text-[#475569] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Monthly Subscription</p>
              <div className="flex items-baseline justify-center gap-1">
                <span className="text-5xl sm:text-6xl font-black text-[#0A192F]" style={{ fontFamily: 'Outfit, sans-serif' }}>$200</span>
                <span className="text-lg font-semibold text-[#475569]">/month</span>
              </div>
            </div>

            {/* What's included */}
            <h3 className="text-lg font-bold text-[#0A192F] mb-5" style={{ fontFamily: 'Outfit, sans-serif' }}>What's included:</h3>
            <ul className="space-y-4 mb-8">
              {[
                { icon: <FileBarChart size={18} />, text: 'Study Results — Full reports from community research studies on topics that matter' },
                { icon: <TrendingUp size={18} />, text: 'Trend Analysis — See how opinions and behaviors are changing over time in our community' },
                { icon: <PieChart size={18} />, text: 'Demographic Insights — Understand the makeup and perspectives of locals and visitors alike' },
                { icon: <BarChart3 size={18} />, text: 'Performance Metrics — NPS scores, satisfaction ratings, and brand perception benchmarks' },
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-[#0A192F] text-[#38BDF8] flex items-center justify-center shrink-0 mt-0.5">
                    {item.icon}
                  </div>
                  <span className="text-sm sm:text-base text-[#475569] leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>{item.text}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <a
              href={STRIPE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="get-skoop-subscribe-btn"
              className="neo-btn w-full py-4 bg-[#38BDF8] text-[#0A192F] text-lg inline-flex items-center justify-center gap-2"
            >
              Start Subscription <ArrowRight size={20} />
            </a>
            <p className="text-xs text-[#475569] text-center mt-4">Secure payment powered by Stripe</p>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-16 sm:py-20 bg-[#0A192F]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Sign Up To Get The SKOOP!
          </h2>
          <p className="text-base text-white/70 mb-10 max-w-xl mx-auto" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Stay ahead with community-powered data and insights.
          </p>
          <a
            href={STRIPE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="get-skoop-bottom-subscribe-btn"
            className="neo-btn inline-flex items-center gap-2 px-10 py-5 bg-[#38BDF8] text-[#0A192F] text-lg"
          >
            Start Subscription <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
}
